import { render, staticRenderFns } from "./FormTextLong.vue?vue&type=template&id=5bcacd41&"
import script from "./FormTextLong.vue?vue&type=script&lang=js&"
export * from "./FormTextLong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports